<template>
  <ul class="op-bread-list">
    <li
      class="bread-item"
      v-for="(item, index) in data"
      :key="index"
      :class="{ active: item.path }"
    >
      <span>{{ item.name }}</span>
      <span class="bread-line" v-if="index !== data.length - 1">/</span>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          name: "API文档"
        },
        {
          name: "商品API"
        },
        {
          name: "baozun.appstore.subscribe.get"
        }
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {}
};
</script>

<style lang="less">
.op-bread-list {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  .bread-item {
    font-size: 12px;
    color: @color-font-primary;
    &.active {
      color: @color-primary;
      cursor: pointer;
    }

    .bread-line {
      color: @color-font-info;
      padding: 0px 4px;
      font-size: 14px;
    }
  }
}
</style>
